// import * as firebase from 'firebase'
import { initializeApp } from 'firebase/app'
import appConfig from './config'

const firebase = initializeApp(appConfig?.FIREBASE_CONFIG)

export default firebase
